var _jsxFileName = "/codebuild/output/src486503337/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/utility/SelectorInput/index.tsx";
import React, { memo } from 'react';
import { KeyboardlessInput } from '@adc/parallax-component-library';
import { IconChevronDown, IconValidationInvalid } from '@adc/parallax-icons';
const SelectorInput = /*#__PURE__*/memo(({
  onClick,
  testID,
  value,
  label,
  children,
  errorMessage,
  error,
  isTouched,
  ...rest
}) => {
  const hasError = isTouched && error;
  return /*#__PURE__*/React.createElement(KeyboardlessInput, Object.assign({
    testID: testID,
    inlineIconConfig: {
      testID: 'chevron-down',
      icon: /*#__PURE__*/React.createElement(IconChevronDown, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 38,
          columnNumber: 17
        }
      }),
      color: '$interactive.tertiary.enabled.onColor'
    },
    onPress: onClick,
    value: value,
    label: label,
    error: hasError,
    supportingIconConfig: hasError ? {
      icon: /*#__PURE__*/React.createElement(IconValidationInvalid, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 45,
          columnNumber: 50
        }
      })
    } : undefined,
    supportingText: hasError ? errorMessage : undefined
  }, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 7
    }
  }), children);
});
SelectorInput.displayName = 'SelectorInput';
export { SelectorInput };